import BaseNetwork from "@/lib/classes/BaseNetwork";
import { derivePubkeyFromXpub } from "@/lib/helpers/derive";
import { Network, payments } from "bitcoinjs-lib";

const dogecoin: Network = {
  messagePrefix: "\x19Dogecoin Signed Message:\n",
  bip32: {
    public: 0x02facafd,
    private: 0x02fac398,
  },
  pubKeyHash: 0x1e,
  scriptHash: 0x16,
  wif: 0x9e,
  bech32: undefined as unknown as string,
};

class DOGE extends BaseNetwork {
  constructor(xpub: string) {
    super("DOGE", xpub);
  }

  getAddress(index: number, derivationPath: number[], xpub: string): string {
    const derivedPubkey = derivePubkeyFromXpub(xpub, [
      ...derivationPath,
      index,
    ]);

    const { address } = payments.p2pkh({
      pubkey: Buffer.from(derivedPubkey.compressed, "hex"),
      network: dogecoin,
    });

    if (!address) throw new Error("Failed to generate BTC address");

    return address;
  }
}

export default DOGE;
